import { ConfigProvider, Layout, Result } from "antd"
import { FLEET_URL, MYPORTAL_URL } from "../../utils/Config"
import { DEFAULT_BTN, getBaseFontSize, PURPLE, RESULT_CONTENT_STYLE, RESULT_STYLE, WHITE } from "../../styles/styleUtils"
import UMCButton from "./UMCButton"
import { useEffect, useState } from "react"
import UMCSidebar from "../Layout/UMCSidebar"
import UMCHeader from "../Layout/UMCHeader"
import { useWindowSize } from "../customHooks/useWindowSize"
import UMCFooter from "../Layout/UMCFooter"
import aleLogo from "../../assets/images/ale-logo.jpg"
import infoIcon from "../../assets/images/icon_info.svg"
import { useDispatch, useSelector } from "react-redux"
import { getTranslated } from "../../utils/CommonUtils"
import { fetchAndConcatenateDictionaries } from "../../store/actions/CommonActions"

export default function UMCResult(props) {

    const [fontSize, setFontSize] = useState()
    const [width] = useWindowSize()
    const dict = useSelector(state => state.common.dict)
    const language = useSelector(state => state.common.language)
    
    const dispatch = useDispatch()

    useEffect(() => {
        setFontSize(getBaseFontSize(width))
    }, [width])

    useEffect(() => {
        if (!Object.keys(dict).length && language) { // fetch dict only if not already present
            fetchAndConcatenateDictionaries(language, dispatch)
        }
    }, [language, dict])

    
    const getUnAuthExtraContent = () => {
        return <>
            <span><div className="back-label">{getTranslated(dict, "LABEL_BACK_TO")}</div>
                <UMCButton
                    type="primary"
                    className="unauth-redir-btn"
                    label={getTranslated(dict, "APP_MYPORTAL")}
                    onClick={() => window.open(MYPORTAL_URL, "_self")}
                />
                <>{getTranslated(dict, "LABEL_OR")}</>
                <UMCButton
                    type="primary"
                    className="unauth-redir-btn"
                    label={getTranslated(dict, "APP_FLEET")}
                    onClick={() => window.open(FLEET_URL, "_self")}
                />
            </span>
        </>
    }

    return (
        <ConfigProvider
            theme={{ // To override antd's default style globally
                token: {
                    fontSize: fontSize,
                    fontFamily: "Noto Sans",
                    colorPrimary: PURPLE
                },
                components: {
                    Button: DEFAULT_BTN,
                    Result: RESULT_STYLE
                }
            }}
        >
            <Layout>
                <Layout>
                    {props.status === 200 ? <UMCSidebar unAuth={true} /> : <></>}
                    <Layout>
                        <UMCHeader unAuth={true} status={props.status} />
                        <Layout.Content style={{
                            ...RESULT_CONTENT_STYLE
                        }}>
                            {props.status === 200 ? <Result
                                style={{ color: PURPLE }}
                                icon={<img src={aleLogo} alt="ALE-logo" className="ale-logo" />}
                                title={getTranslated(dict, props.title)}
                                subTitle={getTranslated(dict, props.subTitle)}
                                extra={getUnAuthExtraContent()}
                            /> : <>
                                <Result
                                    style={{ color: PURPLE }}
                                    icon={<img src={infoIcon} alt="info icon" style={{ height: "4em" }} />}
                                    title={getTranslated(dict, props.title)}
                                    subTitle={getTranslated(dict, props.subTitle)}
                                    extra={getUnAuthExtraContent()}
                                    className="unauth-result"
                                />
                                <div className="ale-unauth-logo-bottom">
                                    <img src={aleLogo} alt="ALE-logo" className="ale-logo" />
                                </div>
                            </>
                            }
                        </Layout.Content>
                    </Layout>
                </Layout>
                <UMCFooter />
            </Layout>
        </ConfigProvider>
    )
}
